module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAdBAMAAAAwW9POAAAAD1BMVEUAAAAMED8MED8MED8MED/zetnwAAAABHRSTlMA+oXzaYBfNAAAADBJREFUKM9jYGBQdEEBQkAhEVQhZ2yqhgFQxPSQCLK3oaqGkbfhfkF4SARdyBmLKgDguSLktc5uRQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/汉堡包@2x.png
// module id = u/xl
// module chunks = 0